import { CoverLevelOption } from './coverLevelOption'
import { Data } from './data'
import { Endorsement } from './endorsement'
import { InsuredAsset } from './insuredAsset'
import { InsuredProfile } from './insuredProfile'

export enum QuoteStatus {
  QUOTE = 'QUOTE',
  REFERRAL = 'REFERRAL',
}

export interface ExcessLine {
  excessCategory: string

  mandatoryExcess: number
  voluntaryExcess: number
  totalExcess: number

  voluntaryExcessCode?: string
}

export interface Quote {
  proposalCode: string
  policyholder: Data
  insuredAssets: InsuredAsset[]
  insuredProfiles: InsuredProfile[]
  endorsements: Endorsement[]
  promoCode?: string
  wordingVersion: string
  ratingStatus: QuoteStatus
  riskProfileId: string
  referralReasons: ReferralReason[]
  requestedOptionalCovers: Record<string, boolean>
  mainInsurer: string
  availableCoverLevelOptions: CoverLevelOption[]
  excessLines: ExcessLine[]
  voluntaryExcesses: Record<string, number>
}

export interface ReferralReason {
  message: string
}
